import React, { Fragment } from "react";
import "./bars.scss";
import useFormatParties from "../../dataProvider/hooks/useFormatParties";

const Bars = ({
  currentData,
  pastData,
  year,
  electionNumber,
  electionType,
  placeId,
  orientation = "vertical",
  excludes
}) => {
  const partyFormats = useFormatParties(currentData, pastData, year, electionNumber, electionType, placeId, excludes);

  if (!partyFormats) {
    return React.createElement("div", null, "Loading");
  }

  const formatModel = partyFormats.filter(item => item.seats || item.previousSeat);
  return React.createElement(Fragment, null, React.createElement("div", {
    className: orientation + "_barsScroll"
  }, React.createElement("div", {
    className: orientation + "_bars"
  }, formatModel.map((party, index) => React.createElement("div", {
    className: "party",
    key: index
  }, React.createElement("div", {
    className: "partyInfo"
  }, React.createElement("h3", {
    className: "partyName"
  }, party.partyAcronym), React.createElement("span", {
    className: party.seats > party.previousSeat ? "partyEscanos more" : "partyEscanos less"
  }, Math.abs(party.seats - party.previousSeat))), React.createElement("div", {
    className: "barsContainer"
  }, React.createElement("div", {
    className: "bar bar_current",
    style: {
      backgroundColor: party.partyColor,
      width: orientation === "horizontal" ? party.seats * 100 / currentData.totalSeats * 1.7 + "%" : undefined,
      height: orientation === "vertical" ? party.seats * 100 / currentData.totalSeats * 1.7 + "%" : undefined
    }
  }, React.createElement("span", {
    className: "barEscanos"
  }, party.seats)), React.createElement("div", {
    className: "bar bar_past",
    style: {
      backgroundColor: party.partyColor,
      width: orientation === "horizontal" ? party.previousSeat * 100 / pastData.totalSeats * 1.7 + "%" : undefined,
      height: orientation === "vertical" ? party.previousSeat * 100 / pastData.totalSeats * 1.7 + "%" : undefined
    }
  }, React.createElement("span", {
    className: "barEscanos"
  }, party.previousSeat))))))));
};

export default Bars;